import { useHits } from 'react-instantsearch';

import { Container } from '@/atoms';
import { CardFlat, ProductBlock, SliderCard } from '@/molecules';

import { cardTransformer } from '@/graphql/transformers';
import { debug } from '@/lib';
import {
  blockSpacing,
  eyebrowClass,
  sectionBgProps,
  textStyleClass,
} from '@/utils';

const removeCurrentFlat = (propertyId: string, flat: any) =>
  (propertyId && flat.codigoUnidadAlquiler !== propertyId) || !propertyId;

/**
 * ComponentRevisadasViviendasMasBuscadas
 */
export const ComponentRevisadasViviendasMasBuscadas = ({
  Eyebrow,
  Columnas,
  Titulo,
  Descripcion,
  TituloEstilo,
  DescripcionEstilo,
  AzulFondo,
  PaddingVertical,
  zfm_disponiblidads,
  propertyId,
  VerMasText,
  VerMasLink,
  FondoSeccion,
  Espaciado,
}: any) => {
  // Strapi enforce min:1 max:4, pero blindamos por si llega null/garbage
  // de entradas antiguas. Default 3 = comportamiento histórico.
  const perPageDesktop =
    typeof Columnas === 'number' && Columnas >= 1 && Columnas <= 4
      ? Columnas
      : 3;
  let hits: any[] = [];

  try {
    const searchContext = useHits();

    if (searchContext) {
      hits = searchContext.hits;
    }
  } catch (err) {
    debug('no context found');
  }

  const flats = hits.length > 0 ? hits : zfm_disponiblidads;
  // Filtra el flat actual y limita a `Columnas` para no pintar de más
  // (el `Configure` upstream pide N+1 hits para garantizar el cupo tras
  // el filtro; sin slice mostraríamos ese extra).
  const validFlats =
    flats
      ?.filter((ele: any) => removeCurrentFlat(propertyId, ele))
      ?.slice(0, perPageDesktop) ?? [];

  return validFlats.length > 0 ? (
    <Container
      wrapper
      {...sectionBgProps(FondoSeccion, AzulFondo ? 'bg-primary-50' : undefined)}
      classNameWrapper={
        // Espaciado (knob nuevo) manda; sin él se mantiene el contrato
        // legacy exacto: PaddingVertical=true → py-6, si no → sin padding.
        // (blockSpacing sin Espaciado devolvía block-padding y metía
        // 48/80px a tenants que nunca lo pidieron.)
        Espaciado
          ? blockSpacing(Espaciado)
          : PaddingVertical
            ? 'py-6'
            : undefined
      }
    >
      <ProductBlock
        eyebrow={Eyebrow}
        title={Titulo}
        description={Descripcion}
        eyebrowStyleClass={eyebrowClass(null)}
        titleStyleClass={textStyleClass(TituloEstilo)}
        descriptionStyleClass={textStyleClass(DescripcionEstilo)}
      >
        <SliderCard
          perPage={perPageDesktop}
          breakpoints={{
            1024: {
              perPage: perPageDesktop,
            },
            768: {
              padding: 38,
              perPage: 2,
              gap: 16,
            },
            500: {
              padding: 30,
              perPage: 1,
            },
          }}
          {...(VerMasText &&
            VerMasLink && {
              link: {
                label: VerMasText,
                href: VerMasLink,
              },
            })}
        >
          {validFlats
            .map((ele: any, index: number) => (
              <CardFlat
                key={index}
                {...cardTransformer(
                  ele,

                  () => {},
                )}
              />
            ))
            .filter(Boolean)}
        </SliderCard>
      </ProductBlock>
    </Container>
  ) : null;
};

ComponentRevisadasViviendasMasBuscadas.displayName =
  'ComponentRevisadasViviendasMasBuscadas';
